import {Component, NgModule, OnInit} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {GameSetUpService} from './providers/gameSetUp.service';
import {FinishListService} from './providers/finishList.service';
import {LastGamesService} from './providers/lastGames.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public teams: any = [];
  public isGameRunning = false;
  public restoredGameData = null;

  public teamNames = [
    'Player 1',
    'Player 2',
    'Player 3',
    'Player 4'
  ];


  constructor(public gameSetUpService: GameSetUpService, public lastGamesService: LastGamesService) {
  }

  ngAfterViewInit() {
    // FastClick.attach(document.body);
  }

  ngOnInit() {
    if (localStorage.getItem('currentGame') != null) {
      console.log('GGAAAAAAMEEEE');
      this.restoredGameData = JSON.parse(localStorage.getItem('currentGame'));
      this.isGameRunning = true;
    } else {
      console.log('NOOO GGAAAAAAMEEEE');
    }

    setTimeout(() => {
      document.getElementById('splash-screen').classList.add('disappear');
    }, 1000);
  }


  onCreateGame() {
    console.log('createGame', typeof this.gameSetUpService.points);

    this.teams = [];

    let teamCount: number = this.gameSetUpService.teamCount;
    let setCount: number = this.gameSetUpService.sets;
    let legCount: number = this.gameSetUpService.legs;
    let teams: number = this.gameSetUpService.teams;


    for (let i = 0; i < teamCount; i++) {
      this.teams.push(teams[i]);

      if (this.teams[i].name == null) {
        this.teams[i].name = this.teamNames[i];
      }

      this.teams[i].sets = this.buildSetsArr(setCount, legCount);
    }

    this.saveGameSetUp();
    console.log(this.teams);

    this.isGameRunning = true;

  }


  saveGameSetUp() {
    let currentGame = {
      gameMode: this.gameSetUpService.gameMode,
      points: this.gameSetUpService.points,
      sets: this.gameSetUpService.sets,
      legs: this.gameSetUpService.legs,
      throws: this.gameSetUpService.throws,
      countUpRounds: this.gameSetUpService.countUpRounds,
      teamCount: this.gameSetUpService.teamCount
    };
    this.lastGamesService.saveGameSetUp(currentGame);
  }


  buildSetsArr(setCount, legCount) {
    let arr = [];
    for (let k = 0; k < setCount; k++) {
      arr.push({
        legs: this.buildLegsArr(legCount)
      });
    }
    return arr;
  }


  buildLegsArr(legCount) {
    let arr = [];
    for (let k = 0; k < legCount; k++) {
      arr.push({
        win: false,
        scores: []
      });
    }
    return arr;
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts